import styled from "styled-components"

export const StyledUser = styled.div`
    .emailVerifiedMessage {
        margin-top : -10px
    }
`;